import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryCustomerTiers() {
  const { customerService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>('customer-tiers', () =>
    customerService.getCustomerTiers()
  );

  return { tierOptions: data, isLoading, isFetching } as const;
}
